import AdminShell from './AdminShell';

export default AdminShell;
